import React, { useState, useCallback, useEffect } from 'react';
import { TextField } from '@shopify/polaris';

export function CurrencyFieldCustom(props) {

    const format = function (val) {
        if (val === null) {
            val = "";
        }

        let newValue = val.toString().replace(/,/g, '');
        let newValueFloat = parseFloat(newValue);

        if (isNaN(newValueFloat)) {
            newValue = '0.00';
        }
        else if (newValueFloat < 0) {
            newValue = '0.00';
        }

        newValue = parseFloat(newValue).toLocaleString('en-US', {
            style: 'decimal',
            maximumFractionDigits: 2,
            minimumFractionDigits: 2
        });

        return newValue;
    }

    const [value, setValue] = useState(format(props.value));

    const handleValueChange = useCallback(
        (newValue) => {
            setValue(newValue);
            props.handleChange(props.fieldName, newValue);
        },
        [props],
    );

    const handleBlur = useCallback(
        () => {
            let newValue = format(value);

            props.handleError(props.fieldName, props.required && (!newValue || parseFloat(newValue) === 0));

            setValue(newValue);
            props.handleChange(props.fieldName, newValue);
        },
        [value, props],
    );

    useEffect(() => {
        setValue(format(props.value));
        // eslint-disable-next-line
    }, [props.fieldName]);

    return (
        <TextField
            id={props.id}
            value={value}
            label={props.label}
            prefix={props.prefix}
            helpText={props.helpText}
            error={props.error}
            onChange={(newValue) => handleValueChange(newValue)}
            onBlur={() => handleBlur()}
            selectTextOnFocus
        />
    );
}